import React, {useState, useRef, useEffect} from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../../assets/main/groups/main-table/array.svg';
import {useAppSelector} from "common/hook";
import {Skeleton} from 'antd';


interface ITimeZoneSelector {
    setSelectedTimeZone: (value: string) => void;
}

export const TimeZoneSelector: React.FC<ITimeZoneSelector> = ({setSelectedTimeZone}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState<string | null>(null);
    const selectorRef = useRef<HTMLDivElement | null>(null);
    const timeZones = useAppSelector((state) => state.schedule.timeZones);

    useEffect(() => {
        if (timeZones.length > 0) {
            setSelectedValue(timeZones[0].label);
        }
    }, [timeZones]);

    const handleTimeZoneChange = (value: string, label: string) => {
        setSelectedTimeZone(value);
        setSelectedValue(label);
        setIsOpen(false);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event: any) => {
        if (selectorRef.current && !selectorRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className={`custom-select ${isOpen ? 'open' : ''}`} ref={selectorRef}>
            <div className="time-zone-selected" onClick={toggleDropdown}>
                {!selectedValue ? <Skeleton.Input active={true}/> : <>{selectedValue}</>}
                <span className={`time-zone-selected-icon ${isOpen ? 'up' : ''}`}>
                    <ArrayIcon/>
                </span>
            </div>
            {isOpen && (
                <div className="time-zone-options">
                    {timeZones.map((timeZone) => (
                        <div
                            key={timeZone.value}
                            className="time-zone-option"
                            onClick={() => handleTimeZoneChange(timeZone.value, timeZone.label)}
                        >
                            {timeZone.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};